var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"tab-progress"},[_c('ProgressTabAdministrator',{staticClass:"tab-progress__half"}),_c('ProgressTabInstallationPartner',{staticClass:"tab-progress__half"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }